var ua = navigator.userAgent;
if ((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
  $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />');
} else {
  $('head').prepend('<meta name="viewport" content="width=960" />');
}
// [SP]ハンバーガをクリックしたらメニューを表示
$(".global-nav-icon").on("click", function () {
  if ($(".global-nav .nav-list").css("display") === "block") {
    $(".global-nav .nav-list").slideUp("1500");
    $("span", this).removeClass("js-drawer-open");
    $(".global-nav").removeClass("active_menu");
    if($(window).scrollTop() == 0){
      $('header').removeClass('header_fixed');
    }
  } else {
    $(".global-nav").addClass("active_menu");
    $(".global-nav .nav-list").slideDown("1500");
    $("span", this).addClass("js-drawer-open");
  }
});

// Windowサイズによってスタイルを変更
$(window).on("load resize", function () {
  if (window.innerWidth > 768) {
    $(".global-nav .nav-list").css("display", "flex");
  } else {
    $(".global-nav .nav-list").css("display", "none");
    $("i").removeClass("js-drawer-open");
    $("i").addClass("js-drawer-close");
  }
});

// アコーディオンメニュー
$(".nav-item").on("click", function () {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $(this).children(".nav-item_sub").slideToggle();
    $(".nav-item").not($(this)).children(".nav-item_sub").slideUp();
  }
});

$(function () {
  $('.menu-01').on('click', function () {
    $('.menu-list-01').slideToggle();
  });
});

$(window).on('load', function () {
  $(function ($) {
    // 追従させたい要素のクラス名を宣言
    var hoge = $('header');
    offset = hoge.offset();
    $(window).scroll(function () {
      if ($(window).scrollTop() > offset.top) {
        // 追従させたい要素の位置までスクロールしたらクラス付与
        hoge.addClass('header_fixed');
      } else {
        // それ以外はクラスを外す
        if ($(".global-nav .nav-list").css("display") !== "block") {
          hoge.removeClass('header_fixed');
        }
      }
    });
  });
});


$('.brand_slide').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 9000,
  arrows: false,
  cssEase: 'linear',
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 5
    }
  }]
});


$(function () {
  

  $('.secList').on('click', function () {
    if($(this).attr('class') == "secList"){
      $('.secList').addClass("show");
      $('.search_form').fadeIn();
    } else {
      $('.secList').removeClass("show");
      $('.toggle-section').fadeOut();
    }
  });
});


$(function () {
  $("#acmenu").on("click", 'h5', function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
    $('#acmenu h5').not($(this)).siblings('.search_box').slideUp();
  });
});

$(function () {
  // liの数を取得
  const listItems = $(".list_page li").length;
  $(".list_page").each(function () {
    // 最初に表示させるliの数
    let num = 30,
      // 閉じた時に表示させるliの数
      closeNum = num - 1;
    // 最初はもっと見るボタン表示、閉じるボタン非表示
    $(this).find(".item_more").show();
    $(this).find(".js-btn-close").hide();
    // 5行目まで表示
    $(this)
      .find("li:not(:lt(" + num + "))")
      .hide();
    // もっと見るボタンがクリックされた時
    $(".item_more").click(function () {
      // numに+5ずつしていく = 5行ずつ追加する
      num += 30;
      $(this)
        .parent()
        .find("li:lt(" + num + ")")
        .slideDown();
      // liの数よりnumが多い時、
      if (listItems <= num) {
        // もっと見るボタン非表示
        $(".item_more").hide();
        // 閉じるボタン表示
        $(".js-btn-close").show();
        // 閉じるボタンがクリックされたら、
        $(".js-btn-close").click(function () {
          $(this)
            .parent()
            .find("li:gt(" + closeNum + ")")
            // 6行目以降は非表示
            .slideUp();
          // 閉じるボタンを非表示
          $(this).hide();
          // もっと見るボタン表示に
          $(".item_more").show();
        });
      }
    });
  });
});


$(".openbtn1").click(function () { //ボタンがクリックされたら
  $(this).toggleClass('active'); //ボタン自身に activeクラスを付与し
  $("#g-nav").toggleClass('panelactive'); //ナビゲーションにpanelactiveクラスを付与
});

$("#g-nav a").click(function () { //ナビゲーションのリンクがクリックされたら
  $(".openbtn1").removeClass('active'); //ボタンの activeクラスを除去し
  $("#g-nav").removeClass('panelactive'); //ナビゲーションのpanelactiveクラスも除去
});

$(function () {
  $(".item_slider").slick({
    asNavFor: ".thumbnail",
    prevArrow: '<button class="uj-slick-prev uj-slick-arrow" aria-label="Previous" type="button" style="">Previous</button>',
    nextArrow: '<button class="uj-slick-next uj-slick-arrow" aria-label="Next" type="button" style="">Next</button>'
  });
  $(".thumbnail").slick({
    slidesToShow: 5,
    asNavFor: ".item_slider",
    focusOnSelect: true,
    prevArrow: '<button class="uj-slick-prev uj-slick-arrow" aria-label="Previous" type="button" style="">Previous</button>',
    nextArrow: '<button class="uj-slick-next uj-slick-arrow" aria-label="Next" type="button" style="">Next</button>'
  });
});



$(function () {
  // タイトルをクリックすると
  $(".js-accordion-title").on("click", function () {
    // クリックした次の要素を開閉
    $(this).next().slideToggle(300);
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(this).toggleClass("open", 300);
  });
});

$(function () {
  var selectors = {
    sizeChart: '.size_chart'
  };

  $(selectors.sizeChart).magnificPopup({
    type: 'inline',
    midClick: true,
    closeBtnInside: true,
    closeMarkup: '<button title="%title%" type="button" class="mfp-close"> close chart </button>'
  });
});
$(function () {
  var selectors = {
    container: '.cancellation_alert'
  };

  $(selectors.container).magnificPopup({
    type: 'inline',
    midClick: true,
    closeBtnInside: true,
    closeMarkup: '<button title="%title%" type="button" class="mfp-close"> close </button>'
  });
});
$(function () {
  var selectors = {
    container: '.shipping_information_alert'
  };

  $(selectors.container).magnificPopup({
    type: 'inline',
    midClick: true,
    closeBtnInside: true,
    closeMarkup: '<button title="%title%" type="button" class="mfp-close"> close </button>'
  });
});